import ResetRequest from "../../components/ResetRequest";

export const ResetRequestPage = () => {
	return (
		<div className="flex w-full justify-center items-center p-10 bg-gradient-to-br from-cyan-100 to-fuchsia-200">
			<ResetRequest />
		</div>
	);
};
